import { render, staticRenderFns } from "./ApplyStatusDetail.vue?vue&type=template&id=25ecc2f8&scoped=true&"
import script from "./ApplyStatusDetail.vue?vue&type=script&lang=js&"
export * from "./ApplyStatusDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApplyStatusDetail.vue?vue&type=style&index=0&id=25ecc2f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ecc2f8",
  null
  
)

export default component.exports